/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-23 06:53:36
 *
 *******************************************************/
// @flow

import _ from 'lodash';

class ReviewRatingsHelper {
  /**
   * Init values from first loading
   *
   * @param  {object} filterOption  filter option value
   * @param  {object} initialValue default values
   *
   * @return {object}               init values
   */
  static initialValues = (filterOption, initialValue) => {
    const { showExactRating, selectType, starColor } = filterOption;
    const reviewRatingsDisplayType = showExactRating
      ? 'selected_ratings_only'
      : 'seleted_ratings_and_above';

    // Revert option select to single if display type is seleted_ratings_and_above
    const reviewRatingsOptionSelect = !showExactRating ? 'single' : selectType;

    // reviewRatingsStarColor
    const reviewRatingsStarColor = { hex: starColor };

    const result = {
      ...initialValue,
      reviewRatingsDisplayType,
      reviewRatingsOptionSelect,
      reviewRatingsStarColor
    };

    return result;
  };

  /**
   * Build filter option data based on input values
   *
   * @param  {object} filterOption    input values
   * @param  {object} defaultValues   default values
   *
   * @return {object}                 filter option values
   */
  static buildFilterOptionValues = (filterOption, defaultValues) => {
    const {
      reviewRatingsDisplayType,
      reviewRatingsOptionSelect,
      reviewRatingsStarColor
    } = filterOption;

    // Build exact rating value based on display type
    const showExactRating = reviewRatingsDisplayType === 'seleted_ratings_and_above' ? false : true;

    // Revert option select to single if display type is seleted_ratings_and_above
    const selectType =
      reviewRatingsDisplayType === 'seleted_ratings_and_above'
        ? 'single'
        : reviewRatingsOptionSelect;

    // Convert hsv to hex
    let starColor = _.get(reviewRatingsStarColor, 'hex', '#FFD117');

    return {
      ...defaultValues,
      displayType: 'rating',
      showExactRating,
      selectType,
      starColor,
      valueType: null
    };
  };

  /**
   * Fake product data for stock status
   *
   * @param  {object} filterOption
   * @return {array}              list of product count
   */
  static fakeProductValues = filterOption => {
    const { showExactRating } = filterOption;
    let values = [];

    if (showExactRating) {
      values = [
        { key: '1.0-1.49', from: 1, to: 1.49, doc_count: Math.floor(Math.random() * 100) + 1 },
        { key: '1.5-2.49', from: 1.5, to: 2.49, doc_count: Math.floor(Math.random() * 100) + 1 },
        { key: '2.5-3.49', from: 2.5, to: 3.49, doc_count: Math.floor(Math.random() * 100) + 1 },
        { key: '3.5-4.49', from: 3.5, to: 4.49, doc_count: Math.floor(Math.random() * 100) + 1 },
        { key: '4.5-*', from: 4.5, doc_count: Math.floor(Math.random() * 100) + 1 }
      ];
    } else {
      values = [
        { key: '1.0-*', from: 1, doc_count: Math.floor(Math.random() * 100) + 1 },
        { key: '2.0-*', from: 2, doc_count: Math.floor(Math.random() * 100) + 1 },
        { key: '3.0-*', from: 3, doc_count: Math.floor(Math.random() * 100) + 1 },
        { key: '4.0-*', from: 4, doc_count: Math.floor(Math.random() * 100) + 1 },
        { key: '5.0-*', from: 5, doc_count: Math.floor(Math.random() * 100) + 1 }
      ];
    }

    return values;
  };
}

export default ReviewRatingsHelper;
